import { setTokenGetter } from '@/api/client'
import { updateAuthToken } from '@/lib/auth-service-worker'
import { supabase } from '@/lib/supabase'
import { useAuthStore } from '@/store/useAuthStore'

/** 現在のアクセストークン。期限が近ければ supabase-js が更新してから返す */
export const getAccessToken = async (): Promise<string | null> => {
  const { data } = await supabase.auth.getSession()
  return data.session?.access_token ?? null
}

/** API が 401 を返したときに、期限前でもトークンを更新し直す */
const forceRefreshAccessToken = async (): Promise<string | null> => {
  const { data, error } = await supabase.auth.refreshSession()
  if (error) {
    console.warn('[Auth] Failed to refresh session:', error)
    return null
  }
  return data.session?.access_token ?? null
}

/**
 * 認証の初期化（アプリ起動時に 1 回だけ呼ぶ）
 *
 * - API クライアントにトークン取得関数を渡す
 * - セッションの変化（復元・サインイン・トークン更新・サインアウト）をストアと Service Worker に反映する
 */
export const initAuth = (): void => {
  setTokenGetter(getAccessToken, forceRefreshAccessToken)

  // コールバック内で supabase.auth の他メソッドを await するとデッドロックするので、状態の反映だけにする
  supabase.auth.onAuthStateChange((_event, session) => {
    useAuthStore.getState().setSession(session)
    updateAuthToken(session?.access_token ?? null)
  })
}

/** この端末だけサインアウトする（他の端末のセッションは残す） */
export const signOut = async (): Promise<void> => {
  const { error } = await supabase.auth.signOut({ scope: 'local' })
  if (error) throw error
}
